import React, { useEffect, useState } from 'react';
import '../styles/HeroNew.css';

const HeroNew = () => {
  const [animatingIndices, setAnimatingIndices] = useState([]);
  
  // Full text combined
  const line1Text = "Tussen de regels en onder de woorden zit het echte verhaal";
  const line2Text = "Alles is communicatie";
  const fullText = line1Text + line2Text;
  
  useEffect(() => {
    const runAnimation = () => {
      // Find positions of E, V, A only in first line
      const ePositions = [];
      const vPositions = [];
      const aPositions = [];
      
      line1Text.split('').forEach((char, index) => {
        if (char.toLowerCase() === 'e') ePositions.push(index);
        if (char.toLowerCase() === 'v') vPositions.push(index);
        if (char.toLowerCase() === 'a') aPositions.push(index);
      });
      
      // Pick a random V first
      const selectedV = vPositions[Math.floor(Math.random() * vPositions.length)];
      
      // Pick an E that comes before the V and not adjacent
      const validEPositions = ePositions.filter(pos => 
        pos < selectedV && Math.abs(pos - selectedV) > 1
      );
      const selectedE = validEPositions.length > 0 
        ? validEPositions[Math.floor(Math.random() * validEPositions.length)]
        : ePositions[0]; // fallback to first E if none valid
      
      // Pick an A that comes after the V and not adjacent to V or E
      const validAPositions = aPositions.filter(pos => 
        pos > selectedV && 
        Math.abs(pos - selectedV) > 1 &&
        Math.abs(pos - selectedE) > 1
      );
      const selectedA = validAPositions.length > 0
        ? validAPositions[Math.floor(Math.random() * validAPositions.length)]
        : aPositions[aPositions.length - 1]; // fallback to last A if none valid
      
      // Animate E first
      setTimeout(() => {
        setAnimatingIndices([selectedE]);
      }, 0);
      
      // Add V (E stays)
      setTimeout(() => {
        setAnimatingIndices([selectedE, selectedV]);
      }, 1500);
      
      // Add A (E and V stay)
      setTimeout(() => {
        setAnimatingIndices([selectedE, selectedV, selectedA]);
      }, 3000);
      
      // Hold all three for longer
      setTimeout(() => {
        setAnimatingIndices([selectedE, selectedV, selectedA]);
      }, 4500);
      
      // Remove E
      setTimeout(() => {
        setAnimatingIndices([selectedV, selectedA]);
      }, 6000);
      
      // Remove V
      setTimeout(() => {
        setAnimatingIndices([selectedA]);
      }, 6500);
      
      // Remove A
      setTimeout(() => {
        setAnimatingIndices([]);
      }, 7000);
    };
    
    // Run immediately
    runAnimation();
    
    // Repeat every 10 seconds
    const interval = setInterval(runAnimation, 10000);
    
    return () => clearInterval(interval);
  }, [line1Text]);
  
  // Parallax effect for hero image
  useEffect(() => {
    const heroImage = document.querySelector('.hero-image');
    
    const handleScroll = () => {
      if (window.innerWidth > 768) {
        const scrolled = window.pageYOffset;
        const rate = scrolled * 0.5;
        
        if (heroImage) {
          heroImage.style.transform = `translateY(${rate}px)`;
        }
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  
  let globalIndex = 0;
  
  const renderTextWithAnimation = (text) => {
    const words = text.split(' ');
    
    return words.map((word, wordIndex) => {
      const letters = word.split('').map((char, charIndex) => {
        const currentIndex = globalIndex;
        globalIndex++;
        
        const isAnimating = animatingIndices.includes(currentIndex);
        
        return (
          <span 
            key={`${currentIndex}`} 
            className={`letter ${isAnimating ? 'grow-letter' : ''}`}
          >
            {char}
          </span>
        );
      });
      
      // Increment for the space
      if (wordIndex < words.length - 1) {
        globalIndex++;
      }
      
      return (
        <React.Fragment key={`word-${wordIndex}`}>
          <span className="word">
            {letters}
          </span>
          {wordIndex < words.length - 1 && ' '}
        </React.Fragment>
      );
    });
  };

  return (
    <section className="hero">
      <div className="hero-image">
        <img src="/images/hero-eva-baris.jpg" alt="Eva Baris Atelier - What's Your Story" />
        <div className="hero-overlay"></div>
      </div>
      <div className="container">
        <div className="hero-content">
          <h1 className="text-balance">
            {(() => {
              globalIndex = 0;
              return (
                <>
                  <span className="line-1">
                    {renderTextWithAnimation("Tussen de regels en onder de woorden zit het echte verhaal")}
                  </span>
                  <span className="line-2">
                    {renderTextWithAnimation("Alles is communicatie")}
                  </span>
                </>
              );
            })()}
          </h1>
          <p className="hero-subtitle">
            Senior communicatieadviseur. 20+ jaar corporate communicatie, arbeidsmarktcommunicatie en storytelling.
          </p>
        </div>
      </div>
    </section>
  );
};

export default HeroNew;